import React, { FC } from 'react';

import { Box, Image } from '@chakra-ui/react';

import GetManagementGroupOrSubscriptionId from './GetManagementGroupOrSubscriptionId.png';

export const GettingManagementGroupId: FC = () => {
  return (
    <Box>
      <Image src={GetManagementGroupOrSubscriptionId} />
    </Box>
  );
};
